module.exports = __webpack_public_path__ + "img/taiwan.00665b5.webp";